module.exports = __webpack_public_path__ + "static/media/Biz-Group.a6d306c7.png";